/* eslint-disable react/jsx-props-no-spreading, jsx-a11y/alt-text */
import React, { FC } from 'react';
import clsx from 'clsx';

interface ImageComponentProps {
  className?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [x: string]: any;
}

const Image: FC<ImageComponentProps> = ({
  className,
  ...rest
}) => (
  <img {...rest} className={clsx('img-responsive', className)} />
);

export default Image;
